import React, { createContext } from 'react'

export const OrderContext = createContext({
    orders: [],
    selectedOrder: '',
    chatHistory: [],
})
